@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
	--jF-theme-color: #19cc76;
	--jF-theme-accent: #142f48;
	--jF-theme-h-text: #142f48;
	--jF-hover-color: #18b368;
	--jF-breakdown-bg-color: #142f48;
	--jF-bullet-bg: #18b368;
}

select {
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20fill='none'%20viewBox='0%200%2020%2020'%3E%3Cpath%20stroke='%236b7280'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='1.5'%20d='M6%208l4%204%204-4'/%3E%3C/svg%3E");
	background-position: right 0.5rem center;
	background-repeat: no-repeat;
	background-size: 1.5em 1.5em;
	padding-right: 2.5rem;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}

ul li,
ol li {
	list-style-type: inherit;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	font-size: inherit;
	font-weight: inherit;
	font-family: inherit;
}

p {
	font-size: inherit;
	font-family: inherit;
	font-weight: inherit;
	padding-bottom: 0px;
}

#modalCloseBtn {
	display: block;
	position: absolute;
	right: 10px;
	top: 10px;
	transition: transform 0.25s var(--ease);
	width: 44px;
	height: 44px;
	padding: 0;
	z-index: 9080;
	border: none;
	background-color: hsl(214, 37%, 94%);
	border-radius: 50%;
}

#modalCloseBtn span {
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

#modalCloseBtn span:before,
#modalCloseBtn span:after {
	content: "";
	position: absolute;
	display: block;
	width: 0.9375rem;
	height: 0.125rem;
	background-color: #142f48;
	transition: transform 0.25s var(--ease), width 0.25s var(--ease);
}

#modalCloseBtn span:after {
	transform: rotate(-45deg);
}

#modalCloseBtn span:before {
	transform: rotate(45deg);
}
